<div class="one-panel-item" [ngClass]="{'activate': activated}">
  <div class="panel-item-icon" *ngIf="iconClass != ''">
    <span class="far {{iconClass}}"></span>
  </div>
  <div class="panel-item-label">
    {{label | translate }}
  </div>

</div>
